import { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    OnboardingPlusSubscriptionOfferNavigatedV5To,
    onboardingPlusSubscriptionOfferNavigatedV5,
    onboardingPlusSubscriptionOfferShowedV5,
    onboardingPlusSubscriptionOfferSucceedV4,
} from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';
import { OnboardingPlusOfferEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import {
    OfferPlacementAnalytics,
    TARIFFICATOR_BILLING_PRODUCT_ID,
} from '@/shared/lib/analytics/offer';
import { getOfferTitle } from '@/shared/lib/analytics';

interface SubscriptionOfferData {
    buttonText: string;
    offer: Offer | null;
    entityType?: string;
}

type SubscriptionOfferAnalytics = OfferPlacementAnalytics<SubscriptionOfferData>;

const extractOfferAnalyticsData = (offer: Offer | null) => ({
    tariffName: offer?.catalogCompositeOffer?.tariffOffer?.name ?? '',
    optionName: offer?.catalogCompositeOffer.optionOffers[0]?.name ?? '',
    batchId: offer?.analyticData.batchId ?? '',
    positionId: offer?.analyticData.positionId ?? '',
});

export function createSubscriptionOfferAnalytics(
    eventSender: AnalyticsSender
): SubscriptionOfferAnalytics {
    let data: SubscriptionOfferData | undefined;

    return {
        setData(value) {
            data = value;
        },
        showed() {
            if (!data) return;

            const { buttonText, entityType, offer } = data;
            const { tariffName, optionName } = extractOfferAnalyticsData(offer);

            eventSender.sendOnce(onboardingPlusSubscriptionOfferShowedV5, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                show: offer?.offerPositionsData ?? {},
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: offer?.billingProductIds ?? '',
            });
        },
        navigated() {
            if (!data) return;

            const { buttonText, offer } = data;
            const { tariffName, optionName } = extractOfferAnalyticsData(offer);

            eventSender.send(onboardingPlusSubscriptionOfferNavigatedV5, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                click: offer?.offerPositionsData ?? {},
                entityType: OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: offer?.billingProductIds ?? '',
                to: OnboardingPlusSubscriptionOfferNavigatedV5To.Payment,
            });
        },
        succeeded() {
            if (!data) return;

            const { buttonText, entityType, offer } = data;
            const { tariffName, optionName } = extractOfferAnalyticsData(offer);

            eventSender.send(onboardingPlusSubscriptionOfferSucceedV4, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: offer?.billingProductIds ?? '',
            });
        },
    };
}
